// File: src/features/activities/services/activitiesApi.ts

import { ActivityData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const activitiesApi = apiResource<ActivityData>('activities');
